export const profileColors = [
  "bg-darkseagreen",
  "bg-darksteelblue",
  "bg-thistle",
  "bg-darkkhaki",
  "bg-blueskydull",
];
